import React, { useEffect, useState } from "react";
import { logger } from "helpers/logger";
import wrapperHOC from "@Utils/wrapperHOC";
import { LottieAnimatorType } from "./types";
import config from "@Config/index";

const LottieAnimator: React.FC<LottieAnimatorType> = ({
  animationData,
  renderer,
  id,
  width,
  height,
  loop = true,
  onComplete,
}) => {
  const [animationJsonData, setAnimationData] = useState();
  const S3_BUCKET_URL = (() => {
    if (config.IS_CHINA_APP)
      return `${config.CHINA_STATIC_ASSETS_URL}/image/prod-static-assets/json/`;
    return "https://prod-static-assets.amberstudent.com/json/";
  })();

  const fetchJsonFromS3 = async () => {
    try {
      const response = await fetch(`${S3_BUCKET_URL}${animationData}`);
      const json = await response.json();
      setAnimationData(json);
    } catch (error) {
      logger.error("Error fetching JSON from S3:", error);
    }
  };

  useEffect(() => {
    fetchJsonFromS3();
  }, []);

  useEffect(() => {
    const container = document.getElementById(id);
    let anim: any = null;
    if (container) {
      import("lottie-web").then((lottie: any) => {
        anim = lottie.loadAnimation({
          container,
          animationData: animationJsonData,
          renderer,
          loop,
          autoplay: true,
        });
        if (onComplete) {
          anim.addEventListener("complete", onComplete);
        }
      });
    } else {
      logger.log(`Element with ${id} not found`);
    }
    return () => {
      if (anim) anim.destroy();
    };
  }, [animationJsonData, id, renderer, loop]);

  return animationJsonData ? (
    <div id={id} style={{ width: width || "100%", height: height || "100%" }} />
  ) : null;
};

export default wrapperHOC(LottieAnimator, {
  componentName: "LottieAnimator",
  showForChina: true,
});
